<template>
  <div class="pr-md-24">
    <div class="d-flex justify-end mb-2">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'surgery-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-form
      v-model="valid"
      ref="form"
      lazy-validation
      @submit.prevent="updateSurgery"
      v-if="surgery"
    >
      <v-card elevation="0" outlined class="pr-md-24 pl-md-4 mb-10 pt-4">
        <v-container>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                :counter="35"
                outlined
                label="Name"
                v-model="surgery.name"
                :rules="nameRules"
              ></v-text-field>

              <v-tel-field
                label="Phone"
                outlined
                :rules="phoneRules"
                v-model="surgery.phone"
                required
              ></v-tel-field>

              <v-text-field
                :counter="100"
                outlined
                label="Address"
                :rules="addressRules"
                v-model="surgery.address"
                required
              ></v-text-field>

              <v-text-field
                :counter="20"
                outlined
                label="City"
                v-model="surgery.city"
                :rules="cityRules"
                required
              ></v-text-field>

              <v-checkbox
                v-model="surgery.approved"
                outlined
                hide-details
                label="Is Approved"
              ></v-checkbox>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                :counter="20"
                outlined
                label="Apt no"
                v-model="surgery.aptNo"
                :rules="aptRules"
                required
              ></v-text-field>

              <v-text-field
                :counter="25"
                outlined
                label="State"
                v-model="surgery.state"
                :rules="stateRules"
                required
              ></v-text-field>

              <v-text-field
                :counter="10"
                outlined
                label="Post Code"
                v-model="surgery.postcode"
                :rules="postCodeRules"
                required
              ></v-text-field>

              <v-autocomplete
                v-model="surgery.countryId"
                outlined
                :items="countries"
                :rules="countryRules"
                label="Select Country"
                item-text="name"
                item-value="id"
              ></v-autocomplete>

              <v-autocomplete
                v-model="surgery.surgeryTypeId"
                outlined
                :items="surgeryTypes"
                :rules="surgeryRules"
                label="Select Surgery"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <div class="text-left">
            <v-btn type="submit" color="accent" class="mx-0">Create</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      valid: false,
      surgery: {
        address: "",
        approved: "",
        aptNo: "",
        city: "",
        country: "",
        countryId: "",
        name: "",
        phone: "",
        postcode: "",
        state: "",
        surgeryType: "",
        surgeryTypeId: ""
      },
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 4) || "Name must be at least 4 characters",
        v => (v && v.length <= 35) || "Name must be less than 35 characters"
      ],
      phoneRules: [
        v => !!v || "Phone is required",
        v => (v && v.length >= 8) || "Phone must be at least 8 digits",
        v => (v && v.length <= 20) || "Phone must be less than 20 digits"
      ],
      addressRules: [
        v => !!v || "Address is required",
        v => (v && v.length >= 8) || "Phone must be at least 8 character",
        v => (v && v.length <= 100) || "Phone must be less than 100 characters"
      ],
      aptRules: [
        v => !!v || "Apt no is required",
        v => (v && v.length >= 5) || "Apt no must be at least 5 character",
        v => (v && v.length <= 20) || "Apt no must be less than 20 characters"
      ],
      stateRules: [
        v => !!v || "State is required",
        v => (v && v.length >= 4) || "Name must be at least 4 characters",
        v => (v && v.length <= 25) || "Name must be less than 25 characters"
      ],
      postCodeRules: [
        v => !!v || "PostCode is required",
        v => (v && v.length >= 5) || "PostCode must be at least 5 characters",
        v => (v && v.length <= 10) || "PostCode must be less than 10 characters"
      ],
      cityRules: [
        v => !!v || "City is required",
        v => (v && v.length >= 3) || "City must be at least 3 characters",
        v => (v && v.length <= 35) || "City must be less than 35 characters"
      ],
      countryRules: [v => !!v || "Country is required"],
      surgeryRules: [v => !!v || "Surgery is required"]
    };
  },
  mounted() {
    this.$store.dispatch("surgeries/LOAD_SURGERY_TYPES", {
      from: 0,
      to: 0
    });
    this.$store.dispatch("countries/LOAD_COUNTRIES", {
      from: 0,
      to: 0
    });
  },
  computed: {
    ...mapState({
      countries: state => state.countries.countries,
      surgeryTypes: state => state.surgeries.surgeryTypes
    })
  },
  methods: {
    async updateSurgery() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Creating surgery...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("surgeries/CREATE_SURGERY", this.surgery);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Surgery has been created",
          icon: "info"
        });
      }
    }
  }
};
</script>
